import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AppConfig, CMPS_APP_CONFIG } from '../../app.config';
import { catchErrorLogRet, mapRetrieve } from '../../common/rest.operators';

import { PowerBiReport } from './models/power-bi-report.model';

@Injectable()
export class PowerBiService {
    constructor(
        private readonly _http: HttpClient,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {}

    listReports(reportTypeIds: number[]): Observable<PowerBiReport[]> {
        let params = new HttpParams();
        // eslint-disable-next-line no-return-assign
        reportTypeIds.forEach(
            (e) => (params = params.append('reportTypeIds', e.toString())),
        );
        return this._http
            .get(`${this._appConfig.API_ENDPOINTS.REPORT}/report/power-bi`, {
                params,
            })
            .pipe(mapRetrieve(), catchErrorLogRet([]));
    }
}
